import React from 'react';
import { connect } from 'react-redux';
import { Alert, Share } from 'react-native';
import { isDesktop } from 'react-device-detect';
import keys from '../../config/keys';
import API from '../../utils/api';

import { history } from '../../store/store';
import Layout from '../../hoc/Layout/Layout';
import Button from '../../components/UI/button/button';
import './Bravo.scss';

const Bravo = (props) => {
  window.scrollTo(0, 0);

  const sendMessage = async(userName, userLink) => {
    try {
      await Share.share({
        title: '',
        message:
          `Hello, \n\n`+
          `Pour m'améliorer dans mon travail, je souhaite découvrir ou confirmer mes talents. `+
          `Pour cela je demande des feedbacks grâce à l'application Humoon. `+
          `Pourrais-tu prendre 5min top chrono pour me donner ton feedback : \n`+
          `${userLink} \n\n`+
          `PS : rassure toi, ton feedback est totalement anonyme, je ne verrai que le résultat global de tous les feedbacks reçus. \n\n`+
          `Merci beaucoup, \n`+
          `${userName}`
      });
    } catch (error) {
      Alert.alert(
        'Erreur lors de la demande de feedback',
        error.message,
        [{ text: 'OK', onPress: () => { } }]
      );
    }
  }

  const feedbackRequested = async() => {
    try {
      const userFbCountResult = await API.post('/user/feedbackRequested');
      if (userFbCountResult.status !== 200) {
        throw new Error('Response status unvalid : ' + userFbCountResult.data.msg);
      }
      if (isDesktop) {
        history.push('/no-problem');
      }
    } catch (error) {
      Alert.alert(
        'Erreur lors de la demande de feedback',
        error.message,
        [{ text: 'OK', onPress: () => { } }]
      );
      return;
    }
  }

  const submitHandler = () => {
    if (isDesktop) {
      feedbackRequested();
    } else {
      sendMessage(props.userName, props.userLink);
      setTimeout(() => {
        feedbackRequested();
      }, 500);
    }
  }

  return (
    <Layout>
      <div className='slideBodyBravo'>
        <h2>Bravo !</h2>
        <p>Ta demande de feedback a été envoyée.</p>
        <div className='bravoListContainer'>
          <div className='listContent'>
            <div className='bulletList'></div>
            <p>Tu peux maintenant demander d’autres feedbacks.</p>
          </div>
          <div className='listContent'>
            <div className='bulletList'></div>
            <p>Il t’en faudra au moins 5 pour voir tes résultats.</p>
          </div>
        </div>

        <div className='imageContainer'>
          <div className='contentContainer'>
            <img
              className='rocketShip'
              alt='Rocket ship'
              src={require('../../assets/images/rocketShip.png')} />
            <p className='small'>
              <span>A qui demander un feedback ?</span>
              <br/>
              Si un jour tu devais organiser ton pot de départ, pense aux personnes que tu inviterais.
            </p>
          </div>
        </div>

        <div className='buttonsContainer'>
          <div className='feedbackBtn'>
            <Button clicked={() => submitHandler()}>
              Demander d'autres feedbacks
            </Button>
          </div>
          <div className='laterBtn'>
            <Button btnType='flat' clicked={() => history.push('/no-problem')}>
              Passer
            </Button>
          </div>
        </div>
      </div>
    </Layout>
  );
}

const mapStateToProps = state => {
  return {
    userName: state.user.first_name,
    userLink: `${keys.feedbackUrl}/${state.user.link_url}`
  }
}

export default connect(mapStateToProps)(Bravo);